import React, { useEffect, useRef, useState } from 'react';
import { Instagram, Heart } from 'lucide-react';
import { instagramPosts, siteInfo } from '../../data/mock';

const InstagramFeed = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-24 lg:py-32 bg-[#3D2E35] relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-gradient-to-br from-[#8B4B7C]/20 to-transparent rounded-full blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        {/* Header */}
        <div
          className={`text-center mb-12 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="inline-flex items-center justify-center space-x-3 mb-4">
            <Instagram className="text-[#E8A5C4]" size={32} />
            <span className="text-[#E8A5C4] font-medium text-lg">{siteInfo.instagram}</span>
          </div>
          <h2 className="font-heading text-4xl lg:text-5xl text-white mt-2">
            Suivez-nous sur Instagram
          </h2>
          <p className="text-white/60 mt-4 max-w-xl mx-auto">
            Découvrez nos dernières créations et laissez-vous inspirer par la beauté tropicale
          </p>
        </div>

        {/* Instagram Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {instagramPosts.map((post, index) => (
            <a
              key={post.id}
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className={`group relative aspect-square overflow-hidden rounded-2xl transition-all duration-700 ${
                isVisible
                  ? 'opacity-100 scale-100'
                  : 'opacity-0 scale-95'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <img
                src={post.image}
                alt={`Instagram post ${post.id}`}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              {/* Hover overlay */}
              <div className="absolute inset-0 bg-[#8B4B7C]/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <div className="flex items-center space-x-2 text-white">
                  <Heart size={24} fill="currentColor" />
                  <span className="font-medium">{post.likes}</span>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* CTA */}
        <div
          className={`text-center mt-12 transition-all duration-1000 delay-500 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <a
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-8 py-4 rounded-full bg-white text-[#8B4B7C] font-medium hover:bg-[#E8A5C4] hover:text-white transition-all duration-300"
          >
            <Instagram className="mr-2" size={20} />
            Voir notre profil Instagram
          </a>
        </div>
      </div>
    </section>
  );
};

export default InstagramFeed;
